<template>
  <div>
    <!-- grid toolbar -->
    <v-toolbar flat color="transparent" class="v-toolbar--grid">
      <!-- grid filter -->
      <v-menu
        v-model="filter.dialog"
        :close-on-content-click="false"
        :offset-y="true"
        max-width="300px"
        min-width="300px"
      >
        <template v-slot:activator="{ on }">
          <v-btn class="mr-2" large v-on="on" :class="{'teal--text':filter.active}">
            <v-icon>mdi-tune</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-form ref="form" @submit.prevent="getItems">
            <v-card-title>Filters</v-card-title>
            <v-divider />
            <v-card-text>
              <v-autocomplete
                v-if="!$acl.check('isSekolah')"
                class="mb-3"
                v-model="filter.data.sekolah"
                :items="list.sekolah.data"
                name="Sekolah"
                label="Sekolah"
                placeholder="Sekolah"
                item-text="Nama"
                item-value="IDSekolah"
                :return-object="false"
                outlined
                hide-details
                multiple
                dense
                chips
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    class="chip--select-multi"
                    @click="data.select"
                  >{{ data.item.Nama }}</v-chip>
                </template>
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-item-content v-text="data.item"></v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title class="mb-3" v-html="data.item.Nama"></v-list-item-title>
                      <v-list-item-subtitle
                        class="mb-3"
                        v-html="data.item.Alamat + ' ' +  data.item.Lokasi + ' ' +  data.item.Provinsi + ' ' + data.item.Kode"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
              <v-daterange
                v-model="filter.data.tanggalPeriod"
                presetLabel="Periode"
                name="Periode"
                label="Periode"
                startLabel="Periode Awal"
                endLabel="Periode Akhir"
                display-format="dd-MM-yyyy"
                no-title
                :action-labels="{ apply: 'Terapkan' }"
              ></v-daterange>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-btn text @click="clearFilter">Ulang</v-btn>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="doFilter">Cari</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-menu>

      <!-- grid search -->
      <!-- <v-text-field
        v-model="search.data"
        append-icon="mdi-magnify"
        :label="app.grid.search"
        hide-details
        single-line
        solo
        clearable
      ></v-text-field>-->
      <v-spacer />

      <!-- grid button -->
      <!-- <v-btn class="ml-2" color="cyan white--text" large to="/bidang/baru">
        <span class="hidden-xs-only" v-text="app.grid.create"></span>
        <v-icon :right="!$vuetify.breakpoint.xsOnly">mdi-plus-box</v-icon>
      </v-btn>-->
    </v-toolbar>

    <!-- grid -->
    <v-data-table
      class="elevation-1 table-realisasi"
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      :loading-text="app.grid.loading"
      :no-data-text="app.grid.noData"
      multi-sort
      fixed-header
    >
      <template v-slot:item.Sekolah.Nama="{ item }">
        <v-list-item three-line class="px-0" dense>
          <v-list-item-content>
            <v-list-item-title>
              <v-icon
                class="mt-n1"
                :color="item.Sekolah.Tipe=='negeri'?'blue':'green'"
                x-small
              >mdi-checkbox-blank-circle</v-icon>
              {{item.Sekolah.Nama}}
              &mdash;
              <span
                class="grey--text text--lighten-1"
              >{{item.Sekolah.Kode}}</span>
            </v-list-item-title>
            <v-list-item-subtitle>{{ item.Sekolah.Alamat}} {{ item.Sekolah.Lokasi}} {{item.Sekolah.Provinsi}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template
        v-slot:item.NominalDetail.Nominal1="{ item }"
        class="body-2"
      >{{item.NominalDetail.Nominal1 | currency}}</template>
      <template
        v-slot:item.NominalDetail.Nominal2="{ item }"
        class="body-2"
      >{{item.NominalDetail.Nominal2 | currency}}</template>
      <template
        v-slot:item.NominalDetail.Nominal3="{ item }"
        class="body-2"
      >{{item.NominalDetail.Nominal3 | currency}}</template>
      <template
        v-slot:item.NominalDetail.Nominal4="{ item }"
        class="body-2"
      >{{item.NominalDetail.Nominal4 | currency}}</template>
      <template
        v-slot:item.NominalDetail.Nominal5="{ item }"
        class="body-2"
      >{{item.NominalDetail.Nominal5 | currency}}</template>
      <template
        v-slot:item.NominalDetail.Nominal6="{ item }"
        class="body-2"
      >{{item.NominalDetail.Nominal6 | currency}}</template>
      <template
        v-slot:item.NominalDetail.Nominal7="{ item }"
        class="body-2"
      >{{item.NominalDetail.Nominal7 | currency}}</template>
      <template
        v-slot:item.NominalDetail.Nominal8="{ item }"
        class="body-2"
      >{{item.NominalDetail.Nominal8 | currency}}</template>
      <template
        v-slot:item.NominalDetail.Nominal9="{ item }"
        class="body-2"
      >{{item.NominalDetail.Nominal9 | currency}}</template>
      <template
        v-slot:item.NominalDetail.Nominal10="{ item }"
        class="body-2"
      >{{item.NominalDetail.Nominal10 | currency}}</template>
      <template
        v-slot:item.NominalDetail.Nominal11="{ item }"
        class="body-2"
      >{{item.NominalDetail.Nominal11 | currency}}</template>
      <template
        v-slot:item.NominalDetail.Nominal12="{ item }"
        class="body-2"
      >{{item.NominalDetail.Nominal12 | currency}}</template>

      <template v-slot:item.LastUpdatedDate="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <span dark v-on="on">{{$format.relativeUpdatedDate(item)}}</span>
          </template>
          <span>{{$format.updatedDate(item)}}</span>
        </v-tooltip>
      </template>

      <!-- grid header -->
      <template v-slot:header.Actions>
        <div class="float-right">
          <v-btn icon v-if="filter.active" :class="{'mr-4':sort.active}" @click="clearFilter">
            <v-icon>mdi-filter-remove</v-icon>
          </v-btn>
          <v-btn icon v-if="sort.active" @click="clearSort">
            <v-icon>mdi-sort-variant-remove</v-icon>
          </v-btn>
        </div>
      </template>

      <!-- grid actions -->
      <template v-slot:item.Actions="{ item }">
        <v-menu offset-y close-on-click>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" :loading="item.processing">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="chooseStatusAnggaran(item)">
              <v-list-item-icon>
                <v-icon color="blue">mdi-file-pdf</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Unduh Laporan</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="300px">
      <v-card>
        <v-card-title>Pilih Status Anggaran</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pl-0 pr-0 pb-0 mt-n1 bg-transparent">
          <v-list two-line dense>
            <template v-for="(status,index) in statusItems">
              <v-list-item :key="status.ID" @click="downloadPDF(status, selectedRealisasi)">
                <v-list-item-content>
                  <v-list-item-title>{{status.StatusAnggaran}}</v-list-item-title>
                  <v-list-item-subtitle>{{status.Tahun}}</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-icon>
                  <v-btn icon color="info" :loading="status.processing">
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                </v-list-item-icon>
              </v-list-item>
              <v-divider v-if="index + 1 < statusItems.length" :key="index"></v-divider>
            </template>
          </v-list>
        </v-card-text>
        <!-- <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="secondary" text @click="dialog = false">Batal</v-btn>
          <v-spacer />
          <v-btn color="primary" text @click="saveItem">Simpan</v-btn>
        </v-card-actions>-->
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
// import moment from "moment";
// import VDaterange from "@/components/VDaterange";
export default {
  data() {
    return {
      filter: {
        data: {
          tanggalPelaporan: "",
          tanggalPeriod: {},
          tahun: "",
          sekolah: "",
          pejabat: ""
        },
        disabled: {
          pejabat: true
        },
        query: {}
      },
      dialog: false,
      sort: {
        active: false
      },
      search: {
        awaiting: false,
        data: ""
      },
      table: {
        awaiting: false
      },
      loading: false,
      options: {},
      headers: [
        {
          value: "Sekolah.Nama",
          text: this.$vuetify.breakpoint.xsOnly ? "" : "Sekolah",
          width: "300px"
        },
        {
          value: "Tahun",
          text: "Tahun",
          width: "100px"
        },
        {
          value: "LastUpdatedDate",
          text: "Terakhir Diubah",
          width: "150px"
        },
        {
          value: "Actions",
          width: "50px",
          sortable: false
        },
        {
          value: "NominalDetail.Nominal1",
          text: "Jan",
          width: "115px"
        },
        {
          value: "NominalDetail.Nominal2",
          text: "Feb",
          width: "115px"
        },
        {
          value: "NominalDetail.Nominal3",
          text: "Mar",
          width: "115px"
        },
        {
          value: "NominalDetail.Nominal4",
          text: "Apr",
          width: "115px"
        },
        {
          value: "NominalDetail.Nominal5",
          text: "Mei",
          width: "115px"
        },
        {
          value: "NominalDetail.Nominal6",
          text: "Jun",
          width: "115px"
        },
        {
          value: "NominalDetail.Nominal7",
          text: "Jul",
          width: "115px"
        },
        {
          value: "NominalDetail.Nominal8",
          text: "Agu",
          width: "115px"
        },
        {
          value: "NominalDetail.Nominal9",
          text: "Sep",
          width: "115px"
        },
        {
          value: "NominalDetail.Nominal10",
          text: "Okt",
          width: "115px"
        },
        {
          value: "NominalDetail.Nominal11",
          text: "Nov",
          width: "115px"
        },
        {
          value: "NominalDetail.Nominal12",
          text: "Des",
          width: "115px"
        }
      ],
      items: [],
      totalItems: 0,
      statusItems: [],
      selectedRealisasi: null
    };
  },

  computed: {
    ...mapState({
      app: state => state.app,
      list: state => state.list
    }),
    ...mapGetters("list", ["isTahunLoading, isPejabatLoading"])
  },
  components: {
    VDaterange: () =>
      import(/* webpackChunkName: "Rekening" */ "@/components/VDaterange.vue")
  },
  methods: {
    async getItems() {
      this.loading = true;
      let payload = this.$format.payload(this.options);
      payload.Filter = this.filter.query;
      payload.KeywordFields = [];
      payload.Keyword = this.filter.active
        ? ""
        : this.$format.keyword(this.search.data);

      if (payload.Orders.length == 0)
        payload.Orders = ["-LastUpdatedDate", "-_id"];

      this.$axios
        .post("/report/realisasi/view", payload)
        .then(res => {
          const result = res.data;
          for (let i in result.Data) result.Data[i].processing = false;
          this.items = result.Data;
          this.totalItems = result.Total;
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async downloadPDF(status, realisasi) {
      if (!status || !realisasi) {
        this.$dialog.notify.error(
          "status atau realisasi data tidak ditemukan",
          {
            position: this.app.notification.position
          }
        );
      }

      let periodeAwal = `${status.Tahun}-01-01`;
      let periodeAkhir = `${status.Tahun}-12-31`;

      status.processing = true;
      this.$axios
        .post(`/report/realisasi/print`, {
          Tahun: status.Tahun,
          StatusAnggaran: status.StatusAnggaran,
          IDSekolah: realisasi.Sekolah.IDSekolah,
          PeriodeAwal: periodeAwal,
          PeriodeAkhir: periodeAkhir
        })
        .then(res => {
          window.open(res.data.Data);
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        })
        .finally(() => {
          status.processing = false;
        });
    },

    async deleteItem(item) {
      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menghapus data ?"
      });
      if (confirmation) {
        item.processing = true;
        this.$axios
          .delete(`/administration/bidang/${item._id}`)
          .then(res => {
            if (res.data.Success) {
              this.$dialog.notify.success(res.data.Message, {
                ...this.app.notification
              });
            }
            this.getItems();
          })
          .catch(error => {
            this.$dialog.notify.error(error, {
              position: this.app.notification.position
            });
          })
          .finally(() => {
            item.processing = false;
          });
      }
    },
    chooseStatusAnggaran(item) {
      item.processing = true;
      this.selectedRealisasi = item;
      // getting status anggaran by year
      let filter = new this.$dbflex();
      filter.eq("Tahun", item.Tahun);
      this.$axios
        .post(`/administration/status_anggaran/list`, { Filter: filter.get() })
        .then(res => {
          let data = res.data.Data;

          if (data.length == 1) {
            this.downloadPDF(data[0], this.selectedRealisasi);
          }

          for (let i in data) data[i].processing = false;
          this.statusItems = data;
          this.dialog = true;
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        })
        .finally(() => {
          item.processing = false;
        });
    },
    doFilter() {
      // let filter = new this.$dbflex();
      let data = this.filter.data;
      let startDate = !data.tanggalPeriod.start ? "" : data.tanggalPeriod.start;
      let endDate = !data.tanggalPeriod.end ? "" : data.tanggalPeriod.end;

      this.$axios
        .post("/report/realisasi/view", {
          IDSekolah: data.sekolah,
          PeriodeAwal: startDate,
          PeriodeAkhir: endDate
        })
        .then(res => {
          const result = res.data;
          for (let i in result.Data) result.Data[i].processing = false;
          this.items = result.Data;
          this.totalItems = result.Total;
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetFilter() {
      this.filter.dialog = false;
      this.$refs.form.reset();
    },
    clearFilter() {
      this.$refs.form.reset();
      this.filter.active = false;
      this.filter.query = null;
      this.search.data = "";
      this.getItems();
    },
    clearSort() {
      this.filter.sort = false;
      this.options.sortBy = [];
      this.options.sortDesc = [];
    },
    removeFilterSekolah(item) {
      const index = this.filter.data.sekolah.indexOf(item.Nama);
      if (index >= 0) this.filter.data.sekolah.splice(index, 1);
    },
    ...mapActions("list", ["refreshTahun", "refreshSekolah", "refreshPejabat"]),
    ...mapActions({
      setHeaderFilterVisibility: "status/setVisibility"
    })
  },
  watch: {
    options: {
      handler(v) {
        var delay = 500;
        if (!this.table.awaiting) {
          setTimeout(() => {
            this.sort.active = v.sortBy.length > 0;
            this.getItems();
            this.table.awaiting = false;
          }, delay);
        }
        this.table.awaiting = true;
      },
      deep: true
    },
    "search.data"() {
      var delay = 1000;
      if (!this.search.awaiting) {
        setTimeout(() => {
          this.getItems();
          this.search.awaiting = false;
        }, delay);
      }
      this.search.awaiting = true;
    },

    "filter.data.sekolah"(newVal) {
      this.filter.data.pejabat = "";
      if (newVal.length == 0) {
        this.filter.disabled.pejabat = true;
      } else {
        this.filter.disabled.pejabat = false;
        let payload = { Filter: {} };
        let filters = new this.$dbflex("$or");
        newVal.map(v => {
          filters.eq("IDSekolah", v);
        });
        payload.Filter = filters.get();
        this.refreshPejabat(payload);
      }
    }
  },
  created() {
    this.setHeaderFilterVisibility(true);
  },
  mounted() {
    this.refreshTahun();
    this.refreshSekolah();
  }
};
</script>

<style lang="scss">
$limit: 4;
@for $i from 1 through $limit {
  .table-realisasi table > tbody > tr > td:nth-child(#{$i}),
  .table-realisasi table > thead > tr > th:nth-child(#{$i}) {
    position: sticky !important;
    position: -webkit-sticky !important;
    z-index: 2;
    background: white;
  }
  .theme--dark .table-realisasi table > tbody > tr > td:nth-child(#{$i}) {
    background: #1e1e1e;
  }
  .theme--dark .table-realisasi table > tbody > tr:hover > td:nth-child(#{$i}) {
    background: #616161;
  }

  .theme--light .table-realisasi table > tbody > tr > td:nth-child(#{$i}) {
    background: white;
  }
  .theme--light
    .table-realisasi
    table
    > tbody
    > tr:hover
    > td:nth-child(#{$i}) {
    background: #eeeeee;
  }
  .table-realisasi table > thead > tr > th:nth-child(#{$i}) {
    z-index: 3;
  }
}

// border for end of column setting
.table-realisasi table > tbody > tr > td:nth-child(#{$limit}),
.table-realisasi table > thead > tr > th:nth-child(#{$limit}) {
  border-right: solid thin;
}
.theme--dark .table-realisasi table > tbody > tr > td:nth-child(#{$limit}),
.theme--dark .table-realisasi table > thead > tr > th:nth-child(#{$limit}) {
  border-right-color: rgba(255, 255, 255, 0.12) !important;
}

.theme--light .table-realisasi table > tbody > tr > td:nth-child(#{$limit}),
.theme--light .table-realisasi table > thead > tr > th:nth-child(#{$limit}) {
  border-right-color: rgba(0, 0, 0, 0.12) !important;
}

// left position as column width
.table-realisasi table > tbody > tr > td:nth-child(1),
.table-realisasi table > thead > tr > th:nth-child(1) {
  left: 0;
}

.table-realisasi table > tbody > tr > td:nth-child(2),
.table-realisasi table > thead > tr > th:nth-child(2) {
  left: 300px;
}

.table-realisasi table > tbody > tr > td:nth-child(3),
.table-realisasi table > thead > tr > th:nth-child(3) {
  left: 300px + 100px;
}

.table-realisasi table > tbody > tr > td:nth-child(4),
.table-realisasi table > thead > tr > th:nth-child(4) {
  left: 300px + 150px + 100px;
}

.table-realisasi .v-data-table--fixed-header .v-data-table__wrapper {
  z-index: 4;
  position: relative;
}
</style>